module.exports = __webpack_public_path__ + "static/media/hero@2x.aa8a9ad5.png";